import styled from "styled-components";
import { motion } from "framer-motion";

export const BasicLayout = styled(motion.div)`
  min-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5rem 10rem;
  color: #fff;

  @media (max-width: 1300px) {
    padding: 3rem 7rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 2rem 2rem;
    min-height: auto;
    text-align: center;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
  }
`;

export const Description = styled.div`
  flex: 1;
  z-index: 2;
  padding-right: 5rem;

  h2 {
    font-weight: lighter;
  }

  @media (max-width: 768px) {
    padding-right: 0;
    margin-bottom: 2rem;
  }
`;

export const Hide = styled.div`
  overflow: hidden;
`;
